import React from 'react'
import { connect } from 'react-redux'
import Streetview from '../components/Streetview'

export const StreetviewContainer = props => {
  return (
    <Streetview {...props} />
  )
}

const mapStateToProps = state => {
  return {
    lngLat: state.streetview.lngLat
  }
}

export default connect(mapStateToProps, null)(StreetviewContainer)



// WEBPACK FOOTER //
// ./src/containers/StreetviewContainer.js